import styled from "styled-components";

export const StyledNoticeModalHeader = styled.div`
  background-image: url("/images/modal/notice-banner.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 156px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;

  .header-root {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .header-content {
      display: flex;
      justify-content: center;
      gap: 10px;
      color: white;
      border: 2px solid white;
      padding: 2px 2px;
      font-size: 18px;
      font-weight: 600;

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-family: Inter;
        font-weight: 700;

        img {
          display: flex;
        }
      }
    }
  }
`;

export const StyledNoticeModalBody = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledTitleText = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  color: #222222;
  padding: 0px 24px;
  font-family: "Inter";
  margin-top: 20px;
  text-align: center;
  
`;

export const StyledExplainText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #000000;
  text-align: center;
  justify-content: center;
  padding: 0px 24px;
`;

export const StyledButtonField = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin-top: 28px;
  margin-bottom: 28px;
  font-family: "Inter";
  font-size: 16px;
  gap: 10px;
`;

export const StyledButton = styled.div`
  font-size: 13px;
  color: #CCCCCC;
  line-height: 20px;
  font-weight: 500;
  width: 132px;
  height: 40px;
  border-radius: 10px;
  border: solid 1px #d6d6d6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  cursor: pointer;
`;

export const StyledBlueButton = styled.div`
  font-size: 13px;
  color: #ffffff;
  line-height: 20px;
  font-weight: 500;
  width: 200px;
  height: 40px;
  border-radius: 10px;
  border: solid 1px #3075f6;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3075f6;
  gap: 4px;
  cursor: pointer;

  .item {

    img {
      width: 19px;
      /* height: auto; */
      /* display: flex; */
      /* height: 16px; */
    }
  }
`;
